<template lang="pug">
  .income
    v-container.px-0(:class="isPrinting? 'py-0' : ''" style="max-width:800px")
      ProfitAndLoss(fill-width :pid="pid")

</template>

<script>
import ProfitAndLoss from '@/components/yezzabook/ProfitAndLoss.vue'

export default {
  name: 'YezzaBookReports',
  props: ['pid'],
  components: { ProfitAndLoss },
  computed: {
    isPrinting () {
      if (this.$route.path.includes('print-reports')) {
        return true
      }
      return false
    }
  },
  data: () => ({
  })
}
</script>

<style lang="scss" scoped>
</style>


<style scoped>
</style>
